export const ID = 'id';
export const NAME = 'name';
export const DATE = 'date';
export const DESCRIPTION = 'description';
export const ADDRESS = 'address';
export const START_TIME = 'start_time';
export const END_TIME = 'end_time';
export const COST = 'cost';
export const CURRENCY = 'currency';
export const CANCELLED = 'cancelled';
export const INVITATIONS = 'invitations_attributes';
export const USERS = 'users';
export const IS_PUBLISHED = 'published';
export const UPDATED_EVENT_AT = 'updated_event_at';
